import React, { useState } from 'react';
import StatsCard from '../../../components/cards/StatsCard';
import { Tooltip } from 'reactstrap';

const ProgressCard = ({
  cardTitle,
  tooltipId,
  tooltipTitle,
  tooltipContent,
  progressData,
  deviceLoading,
}) => {
  const [ tooltipOpen, setTooltipOpen ] = useState(false);
  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);

  const tooltipBlockStyle = {
    width: '100%',
    maxWidth: '224px',
    padding: '24px 16px',
    textAlign: 'left',
  };

  const titleStyle = {
    marginBottom: '8px',
    fontSize: '11px',
    fontWeight: 600,
    lineHeight: '16px',
    textTransform: 'uppercase',
    letterSpacing: '.5px',
  };

  const contentStyle = {
    fontSize: '12px',
    lineHeight: '16px',
  };

  return (
    <StatsCard
      title={(
        <span>
          {cardTitle}
          <span>
            <i id={tooltipId} className="mdi mdi-information ml-2" />
            <Tooltip
              placement="top"
              isOpen={tooltipOpen}
              target={tooltipId}
              toggle={() => toggleTooltip()}
              style={tooltipBlockStyle}
            >
              <h5 style={titleStyle}>{tooltipTitle}</h5>
              <div style={contentStyle}>{tooltipContent}</div>
            </Tooltip>
          </span>
        </span>
      )}
      progres={progressData}
      loading={deviceLoading}
    />
  );
}

export default ProgressCard;